module.exports = __webpack_public_path__ + "static/media/drink.5f5f60de.png";